/**
 * `<LoadingState>` — the shared "this surface/panel is fetching" affordance (frontend.md
 * §4.2 — "loading + empty + error are always all three designed").
 *
 * Every surface uses this for the in-flight state so the loading treatment is consistent.
 * `label` lets a panel be specific ("Loading conflicted notes…").
 */

interface LoadingStateProps {
  label?: string;
  /** `inline` for a small spot inside a panel; `block` (default) for a full panel/surface. */
  variant?: 'inline' | 'block';
}

export function LoadingState({
  label = 'Loading…',
  variant = 'block',
}: LoadingStateProps): JSX.Element {
  return (
    <div
      className={`loading-state loading-state--${variant}`}
      role="status"
      aria-live="polite"
    >
      <span className="loading-state__spinner" aria-hidden="true" />
      <span className="loading-state__label">{label}</span>
    </div>
  );
}
